module.exports = __webpack_public_path__ + "static/img/smartstation51.68bf66e6.png";